import { createBrowserRouter } from 'react-router-dom';

// Корневая архитектура: сайт салона живёт в корне (/), админка — на /admin.
// Никаких /s/<slug>/ — один сайт на один деплой.
// basename всегда '/', маршруты — от корня.
import { TenantLayout } from './TenantLayout';
import { AdminLayout } from './AdminLayout';
import { ClientHome } from '@/features/booking/ClientHome';
import { BookingFlow } from '@/features/booking/BookingFlow';
import { BookingSuccess } from '@/features/booking/BookingSuccess';
import { ClientProfile } from '@/features/profile/ClientProfile';
import { OwnerEntry } from '@/features/owner/OwnerEntry';
import { OwnerDashboard } from '@/features/owner/OwnerDashboard';
import { NotFound } from './NotFound';

// /
// /book              — запись
// /book/success      — подтверждение
// /profile           — мои записи
// /admin             — вход владельца
// /admin/dashboard   — кабинет владельца
// /offer             — страница оффера
export const router = createBrowserRouter([
  {
    path: '/',
    element: <TenantLayout />,
    children: [
      { index: true, element: <ClientHome /> },
      { path: 'book', element: <BookingFlow /> },
      { path: 'book/success', element: <BookingSuccess /> },
      { path: 'profile', element: <ClientProfile /> },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <OwnerEntry /> },
          { path: 'dashboard', element: <OwnerDashboard /> }
        ]
      }
    ]
  },
  {
    path: '/offer',
    lazy: () => import('@/features/offer/OfferPage').then((m) => ({ Component: m.OfferPage }))
  },
  {
    path: '*',
    element: <NotFound />
  }
]);
